var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"total-info-block"},[_c('div',{staticClass:"total-info-block-title"},[_vm._v(" "+_vm._s(_vm.$t("component.TotalInfoBlock.found"))+" "),_c('strong',{staticClass:"text-gray-900"},[_vm._v(_vm._s(_vm.formattedTotal))]),_vm._v(" "+_vm._s(_vm.$tc("component.TotalInfoBlock.resultsCountWord", _vm.total))+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }